export const GA_MEASUREMENTID =
  window.SERVER_DATA?.gaMeasurementId ?? "G-PQERLQTB1S";
export const GTM_MEASUREMENTID =
  window.SERVER_DATA?.gtmMeasurementId ?? "GTM-T3PSGTSB";
export const APP_ROOT = window.SERVER_DATA?.appRoot.replace(/\/$/, "") ?? "";
export const MITEK_TIMEOUTSECONDS = window.SERVER_DATA?.mitekTimeoutSeconds
  ? window.SERVER_DATA?.mitekTimeoutSeconds
  : 60;
export const TMXBASEADDRESS =
  window.SERVER_DATA?.tmxBaseAddress ??
  "https://wkvjee5b.paviliononline.io/fp/tags.js";
export const FEO_ENV = window.SERVER_DATA?.environment ?? "dev";
export const FEO_APPKEY =
  window.SERVER_DATA?.feoAppKey ?? "30b88846df9d083f5300340d9aad762d";
export const GLBANOTICELINK =
  window.SERVER_DATA?.glbaNoticeUrl ??
  "https://www.vippreferred.com/glba-notice/";
